import { useQuery } from '@tanstack/vue-query'

import { explorerApi } from '~/api/client'
import { NexonLwWalletBalanceTrackerRequest } from '~/api/repository'
import type { NexonLwWalletBalanceTrackerInfo } from '~/api/repository/models/NexonLwWalletBalanceTrackerInfo'
import type { NexonLwWalletInfo } from '~/api/repository/models/NexonLwWalletInfo'

export const getLivewatchWalletBalanceTracker = () => {
  return useQuery({
    queryKey: [ 'livewatchWalletBalanceTracker' ],
    queryFn: () => explorerApi.lwController.getWalletBalanceTracker({
      requestBody: {
        assetSymbol: 'NEXON',
        periodType: NexonLwWalletBalanceTrackerRequest.periodType.ALL
      }
    }).then(res => livewatchWalletBalanceTrackerDto(res))
  })
}

export type LivewatchWalletBalanceTracker = {
    symbol: string;
    walletList: Array<LivewatchWalletInfo>;
}

export type LivewatchWalletInfo = {
    name: string;
    data: Array<LivewatchWalletBalanceDateInfo>;
}

export type LivewatchWalletBalanceDateInfo = {
    timestamp: string;
    value: string;
}

export const livewatchWalletBalanceTrackerDto = (data: NexonLwWalletBalanceTrackerInfo): LivewatchWalletBalanceTracker => {
  return {
    symbol: data.SB,
    walletList: data.WLLIST.map((item: any) => ({
      name: item.ADDR,
      data: item.DTLIST.map((item: any) => [ Number(item.TS * 1000), Number(item.VAL) ]),
    })),
  }
}